import * as Scrivito from "scrivito";

const CheckboxOptionWidget = Scrivito.provideWidgetClass(
  "CheckboxOptionWidget",
  {
    attributes: {
      text: "string",
    },
    onlyInside: "CheckboxWidget",
  }
);

export default CheckboxOptionWidget;
